(() => {
  const decoration = document.querySelector('lumora-halloween');
  if (!decoration || decoration.dataset.initialized) return;
  decoration.dataset.initialized = 'true';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  let visible = false;
  let host;
  const update = () => {
    const allowed = !motion.matches && !(mobile.matches && decoration.dataset.mobile === 'false');
    decoration.hidden = !host || !allowed;
    decoration.dataset.playing = String(allowed && visible && !document.hidden);
  };
  const observer = new IntersectionObserver(entries => {
    visible = entries.some(entry => entry.isIntersecting);
    update();
  }, { threshold: 0.05 });
  const mount = () => {
    const gallery = document.querySelector('#MainContent media-gallery');
    const next = gallery?.querySelector('[id^="GalleryViewer-"]') || gallery;
    if (next === host) return;
    if (host) { observer.unobserve(host); host.classList.remove('lumora-halloween-host'); }
    host = next;
    visible = false;
    if (host) {
      host.classList.add('lumora-halloween-host');
      host.append(decoration);
      observer.observe(host);
    }
    update();
  };
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', mount);
  motion.addEventListener('change', update);
  mobile.addEventListener('change', update);
  mount();
})();
